<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs7>
          <v-simple-table :fixed-header="true">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 10rem !important;color: #2c6d80;">
                    <editOrder :order="order"/>
                  </th>
                  <th class="text-left" style="color: #2c6d80;"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Universal RTS Number#:</td>
                  <td>{{ order.universal_rts_number }}</td>
                </tr>
                <tr>
                  <td>PPS Number#:</td>
                  <td>{{ order.id }}</td>
                </tr>
                <tr>
                  <td>RTS Number#:</td>
                  <td>{{ order.old_rts_no }}</td>
                </tr>
                <tr>
                  <td>Client Ref #:</td>
                  <td>{{ order.client_reference }}</td>
                </tr>
                <tr>
                  <td>Product:</td>
                  <td>{{ order.product.name }}</td>
                </tr>
                <tr>
                  <td>Created On:</td>
                  <td>{{ order.created_on | formatDate }}</td>
                </tr>
                <tr>
                  <td>Borrower:</td>
                  <td>{{ order.first_borrower }}</td>
                </tr>
                <tr>
                  <td>Address:</td>
                  <td>{{ order.address|formatAddress }}</td>
                </tr>
                <tr>
                  <td>County:</td>
                  <td>{{ order.address.county.name }}</td>
                </tr>
                <tr>
                  <td>State:</td>
                  <td>{{ order.address.state.name }}</td>
                </tr>
                <tr>
                  <td>First Borrower:</td>
                  <td>{{ order.first_borrower }}</td>
                </tr>
                <tr>
                  <td>Last 4 of SSN::</td>
                  <td>{{ order.last_4_of_ssn }}</td>
                </tr>
                <tr>
                  <td>Second Borrower:</td>
                  <td>{{ order.second_borrower }}</td>
                </tr>
                <tr>
                  <td>Last 4 of SSN:</td>
                  <td>{{ order.last_4_of_ssn2 }}</td>
                </tr>
                <tr>
                  <td>Effective Date:</td>
                  <td>{{ order.effective_date | formatDate }}</td>
                </tr>
                <tr>
                  <td>Loan#:</td>
                  <td>{{ order.loan }}</td>
                </tr>
                <tr>
                  <td>Amount:</td>
                  <td>NA</td>
                </tr>
                <tr>
                  <td>sbj_lien_amount:</td>
                  <td>{{ order.subject_lien_amount }}</td>
                </tr>
                <tr>
                  <td>sbj_lien_date:</td>
                  <td>{{ order.prepared_date | formatDate }}</td>
                </tr>
                <tr>
                  <td>Is Developer Deed:</td>
                  <td>{{ order.is_developer_deed }}</td>
                </tr>
                <tr>
                  <td>Borrower Name In Title:</td>
                  <td>{{ order.borrower_name_in_title }}</td>
                </tr>
                <tr>
                  <td>Search Pd St Dt:</td>
                  <td>{{ order.search_pd_st_date | formatDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
        <v-flex xs5>
          <v-flex xs12>
            <notesManager :order="order" :type="noteType"/>
          </v-flex>
          <v-flex xs12 v-if="order.status.slug=='assign'">
            <v-textarea
              outlined
              name="input-7-4"
              label="Assigner Note"
              v-model="assignerNote"
            ></v-textarea>
          </v-flex>
          <v-layout v-if="order.status.slug=='assign'">
            <v-flex xs10>
              <v-combobox
                v-model="select"
                :items="items"
                item-text="first_name"
                label="Select Vendor"
                chips
              >
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    :disabled="data.disabled"
                  >
                  <v-avatar
                    class="accent white--text"
                    left
                    v-text="data.item.first_name.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                    {{ data.item.first_name }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs2>
              <v-btn color="rtsPrimary" dark @click="updateVendor" :loading="aloading">Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import editOrder from '@/components/editOrder.vue'
import notesManager from '@/components/notesManager.vue'
import { GETOVENDORLIST, PATCHORDER, POSTNOTE } from '@/store/actions.type'
import Vue from 'vue'

Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'Assign',
  components: {
    editOrder,
    notesManager
  },
  data () {
    return {
      files: [],
      select: null,
      loading: true,
      aloading: false,
      items: [],
      assignerNote: null,
      noteType: 'Order'
    }
  },
  props: {
    order: null,
    documentPath: null
  },
  mounted () {
    this.loading = true
    this.$store.dispatch(GETOVENDORLIST).then(response => {
      console.log(response)
      this.items = response
      this.loading = false
      console.log(this.items)
    })
  },
  methods: {
    updateVendor () {
      this.loading = false
      this.aloading = true
      let orderUpdateNotePayload = {
        note: `Order assigned to vendor ${this.select.first_name} and moved to Waiting Docs Stage`,
        order: this.order.id,
        type: 'Order'
      }
      this.$store.dispatch(POSTNOTE, orderUpdateNotePayload).then(noteResponse => {
        let payload = {
          id: this.order.id,
          vendor: this.select.id,
          status: 3
        }
        this.$store.dispatch(PATCHORDER, payload).then(response => {
          if (this.assignerNote) {
            let assignerNotePayload = {
              note: this.assignerNote,
              order: this.order.id,
              type: 'Assigner'
            }
            this.$store.dispatch(POSTNOTE, assignerNotePayload).then(noteResponse => {
              console.log(response)
              this.order = response
              this.loading = false
              this.$emit('updateOrder', this.order)
            })
          } else {
            console.log(response)
            this.order = response
            this.loading = false
            this.$emit('updateOrder', this.order)
          }
          this.this.aloading = false
        })
      })
    }
  },
  watch: {
    order: {
      immediate: true,
      handler (newVal, oldVal) {
        this.select = this.order.vendor
        this.tab = 0
      }
    }
  }
}
</script>

<style>
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto;
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}

.statusTab {
  color: #fff !important;
  background-color: #00abab !important;
  border-color: #00abab;
  width: 120px;
  height: 50px !important;
  display: table-cell;
  vertical-align: middle;
  margin-right: 40px;
  font-size: 10px !important;
  font-weight: 900;
}

.activeStatusTab {
  background-color: #4e6692 !important;
  border-color: #4e6692 !important;
  color: #fff !important;
  width: 120px;
  height: 50px !important;
  display: table-cell;
  vertical-align: middle;
  margin-right: 40px;
  font-size: 10px !important;
  font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
  width: 96%;
  background: #d9544f;
  content: "";
  height: 1px;
  position: relative !important;
  padding: 2px;
  top: 40px !important;
  left: 0 !important;
  margin: auto;
  display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
  height: 0px !important;
}
.v-sheet--tile {
  height: 60px !important;
}
</style>
